module.exports = __webpack_public_path__ + "static/media/bg-profile.9438e3c0.png";